import { DeleteAccount, PrivacySummary } from "@/components/account/DataControls";
import { SecuritySection } from "@/components/account/SecuritySection";
import { useMe } from "@/components/app/TrialBanner";
import { LeaveTeamButton } from "@/components/app/TeamGates";
import { CookieSettingsLink } from "@/components/legal/CookieConsent";
import { DemoLogins } from "@/components/account/DemoLogins";

const LeaveTeam = ({ role }) => (
  <section data-testid="leave-team-section" className="rounded-xl border border-[#2A2A2A] bg-[#121212] p-6">
    <h2 className="font-display text-xl">Your team</h2>
    <p className="mt-2 text-sm text-[#A3A3A3]">You're on someone else's workspace as {role === "viewer" ? "a view-only member" : "an editor"}. Leaving removes your access and your private Calibrator chats there; your login stays.</p>
    <LeaveTeamButton className="mt-4" />
  </section>
);

export default function Account() {
  const { data: me } = useMe();
  const member = me && me.role !== "owner";
  return (
    <div data-testid="account-page" className="space-y-4 max-w-4xl">
      <p className="font-mono text-xs text-[#A3A3A3]">ACCOUNT &amp; PRIVACY</p>
      <h1 className="font-display text-3xl md:text-4xl font-semibold mt-1">Account &amp; privacy</h1>
      <SecuritySection />
      {!member && !me?.demo && <DemoLogins />}
      {member && <LeaveTeam role={me.role} />}
      <PrivacySummary />
      <section data-testid="cookie-settings-section" className="rounded-xl border border-[#2A2A2A] bg-[#121212] p-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-display text-xl">Cookies</h2>
          <p className="mt-1 text-sm text-[#A3A3A3]">Choose whether this browser allows analytics and session recording. Necessary cookies always stay on.</p>
        </div>
        <CookieSettingsLink testid="account-cookie-settings" className="rounded-full border border-[#2A2A2A] px-4 py-2 text-xs hover:border-white transition-colors" />
      </section>
      {me?.demo
        ? <p data-testid="demo-account-note" className="rounded-xl border border-[#B026FF]/40 bg-[#B026FF]/10 p-6 text-sm text-[#D9A6FF]">Data export and account deletion are turned off in the demo workspace. Exit the demo to manage your real account.</p>
        : <DeleteAccount member={member} />}
    </div>
  );
}
